module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Regular-0aaf5cf00f0ae5ccd6d30652632f7ffa.woff";